module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-header"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Chapter01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Drunken Motorist")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Chapter02"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Awdrey’s Statement")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Smelter’s Arms")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" A Visit to Pinehurst")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Enter Dr. Priestley")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" Pinehurst Revisited")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Medicine Bottles")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 8")]), _vm._v(" The Vigil")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 9")]), _vm._v(" The Trap")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Man with the Missing Finger")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 11")]), _vm._v(" Lilies of the Valley")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 12")]), _vm._v(" The Treasure Hunt")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 13")]), _vm._v(" What Dobbs Saw")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 14")]), _vm._v(" The Drunken Sailor")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 15")]), _vm._v(" A Strange Tale")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 16")]), _vm._v(" Coningsworth’s Secret")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 17")]), _vm._v(" Found!")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 18")]), _vm._v(" The Ambush")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 19")]), _vm._v(" Pursuit")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 20")]), _vm._v(" The Truth at Last")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preview: Peril at Cranbury Hall")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1318eeb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0